import { u as f } from "./use-gls-event-listener-DthLjIlk.js";
import { G as g } from "./gls-key-BJ4OHh0o.js";
import { j as s } from "./index-CuHybtft.js";
import { g as C } from "./gls-copy-to-clipboard-B1yVSv4o.js";
const u = (e, t) => {
  const r = (n) => {
    var o;
    (o = e.value) != null && o.contains(n.target) || t();
  };
  return {
    addListener: () => {
      setTimeout(() => document.addEventListener("click", r));
    },
    removeListener: () => {
      document.removeEventListener("click", r);
    }
  };
}, m = (e) => {
  if (!e)
    return null;
  const t = s(e);
  return t.oid || t.sub;
}, a = (e, t) => e.length < 2 ? !0 : e.every((r) => r[t] === e[0][t]);
export {
  g as GlsKey,
  C as glsCopyToClipboard,
  a as glsEveryItemHasCommonProperty,
  m as glsGetOidFromToken,
  u as useGlsClickOutside,
  f as useGlsEventListener
};
